import Icon from '../Icon/Icon';
import './Avatar.scss';

interface AvatarProps {
  src: string;
}

export default function Avatar({ src }: AvatarProps) {
  return (
    <div className="avatar">
      {src ? <img src={src} /> : <p>G</p>}
      <div className="verified-container">
        <Icon name="success" />
      </div>
    </div>
  );
}
